import { WorkspaceSmsRegistrationPointOfContactRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/settings/actions/sms/registration/point-of-contact',
)({
  component: WorkspaceSmsRegistrationPointOfContactRoute,
});
